const stagingKeys = {
  staging: (diseaseId: string) => ['staging', diseaseId]
};

export { stagingKeys };
